import { createBrowserRouter } from 'react-router';

import { AppLayout } from './components/AppLayout';
import { AdminsPage } from './pages/AdminsPage';
import { AuditPage } from './pages/AuditPage';
import { HealthPage } from './pages/HealthPage';
import { JobDetailPage } from './pages/JobDetailPage';
import { LoggedOutPage } from './pages/LoggedOutPage';
import { MetricsPage } from './pages/MetricsPage';
import { OverviewPage } from './pages/OverviewPage';
import { RunTimelinePage } from './pages/RunTimelinePage';

/**
 * react-router v7, library mode. `/logged-out` sits OUTSIDE the shell layout on
 * purpose: a signed-out visitor must not see an app frame (it would imply they
 * are still in). Everything inside the layout is session-gated on the API side;
 * a 401 anywhere bounces the browser to the OAuth entry point.
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <OverviewPage /> },
      { path: 'jobs/:id', element: <JobDetailPage /> },
      { path: 'jobs/:id/runs/:run', element: <RunTimelinePage /> },
      { path: 'admins', element: <AdminsPage /> },
      { path: 'audit', element: <AuditPage /> },
      { path: 'metrics', element: <MetricsPage /> },
      { path: 'health', element: <HealthPage /> },
    ],
  },
  { path: '/logged-out', element: <LoggedOutPage /> },
]);
